import { NgModule } from '@angular/core';
import { SalesForceAccountMappingPipe } from './sales-force-account-mapping.pipe';

@NgModule({
    declarations: [SalesForceAccountMappingPipe],
    exports: [SalesForceAccountMappingPipe]
})
export class SalesForceAccountMappingPipeModule {}
